import styled from 'styled-components';

export const Container = styled.label`
  font-weight: bold;
`;
